import { move } from 'ramda';
import { MappedProductGroup } from '../../../../store/api';

export const MOVE = { down: 1, up: -1 };

export function moveProductGroup(productGroups: MappedProductGroup[], slotId: number, direction: number) {
    const FIRST_SLOT_INDEX = 0;
    const LAST_SLOT_INDEX = productGroups.length - 1;

    if (
        (slotId === FIRST_SLOT_INDEX && direction === MOVE.up) ||
        (slotId === LAST_SLOT_INDEX && direction === MOVE.down)
    )
        return productGroups;

    if (![MOVE.up, MOVE.down].includes(direction)) {
        // The second argument of moveAndSaveProductGroup has to be either MOVE.down or MOVE.up
        return productGroups;
    }

    return move(slotId, slotId + direction, productGroups);
}
